<template>
    <BaseModal :title="title" @close="closeModal" :visible="true" size="small">
        <div class="learner__easily__popup">
            <div class="select__options__wrapper">
                <h5 class="title">Please Select Yes/No</h5>
                <div class="select__btn__group">
                    <button class="popup__btn solid__btn skipgrp" type="button" @click="handleModal('saved')">yes</button>
                    <button class="popup__btn trans__btn" type="button" @click="handleModal('close')">no</button>
                </div>
                <div class="popup__note__info">
                    <p>If this learner can not accurately repeat 2-syllable phrases, click No, and you will start
                        assessing at Group 1, per Dr. Esch.
                    </p>
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '../BaseModal.vue';

// eslint-disable-next-line
const emit = defineEmits(['close', 'saved']);

const title = `If this learner can accurately repeat 2-syllable phrases, click Yes, and 
    the app will give this learner full credit for Groups 1 and 2, as per Dr. Esch, and take you to Group 3.`;

const showModal = ref(true);

const closeModal = () => {
    showModal.value = false;
    emit('close');
};

const handleModal = (action = 'close') => {
    showModal.value = false;
    emit(action);
};
</script>
